export default "__VITE_ASSET__CN6JjflS__"